import React from 'react';
import ErrorsHigherOrderComponent from 'views/ErrorsHigherOrderComponent';
import FormFieldWrapper from './FormFieldWrapper';
import FormField from './FormField';
import classNames from 'classnames';

export default class Form extends ErrorsHigherOrderComponent {
  constructor () {
    super();
  }

  render () {
    let { errors } = this.props;
    errors = typeof errors === 'string' && errors.length ? [errors] : errors;
    const classesFromParent = this.props.className || '';

    return (
      <form className={classNames('form', classesFromParent)} onSubmit={this.props.onSubmit} noValidate>
        {
          errors && Array.isArray(errors)
          ?
          <FormFieldWrapper columns="small-12">
            <FormField className="alert-banner area--red push--bottom soft-half">
              {this.getErrorsBlock(errors)}
            </FormField>
          </FormFieldWrapper>
          : null
        }
        {this.props.children}
      </form>
    );
  }

}



// WEBPACK FOOTER //
// ./src/common/views/form/Form.js